export const SECURITY_CONTEXT_PATHS = ['/live-class-view', '/consultation-view']
